import React, { useState } from 'react';
import { Mail, Phone, MapPin, Globe, Facebook, Twitter, Instagram } from 'lucide-react'; 
import contactimg from '../assets/images/contact-illus.jpg';
const handleSubmit = (e) => {
    e.preventDefault();
    alert("Form submitted! (This is a placeholder action)");

};

const ContactPage = () => {
    
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        description: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    return (
<div>
            <div className="contact-page-container">
            <main className="contact-page-main-layout">
                
              
                <div className="contact-page-info-panel">
                    <div className="contact-page-illustration-container">
                  
                        <img 
                            src={contactimg} 
                            alt="Customer Support Illustration"
                            className="contact-page-illustration"
                        />
                   
                    </div>

                    <div className="contact-page-info-group">
                       
                        <h4 className="contact-page-info-label">Address</h4>
                        <p className="contact-page-info-text">NY State Thruway, New York, USA</p>
                    </div>

                    <div className="contact-page-info-group">
                  
                        <h4 className="contact-page-info-label">Phone</h4>
                        <p className="contact-page-info-text">+1 20290122122</p>
                    </div>
                    
                    <div className="contact-page-info-group">
                      
                        <h4 className="contact-page-info-label">Email Address</h4>
                        <p className="contact-page-info-text">demo@demo.com</p>
                    </div>
                    
                    <div className="contact-page-info-group contact-page-website">
                     
                        <h4 className="contact-page-info-label">Website</h4>
                        <div className="contact-page-website-details">
                            <p className="contact-page-info-text">https://test.io</p>
                            <a href="https://test.io" target="_blank" rel="noopener noreferrer" className="contact-page-visit-btn">Visit This Site</a>
                        </div>
                    </div>

                    <div className="contact-page-follow-us">
                        <h4 className="contact-page-follow-label">Follow Us</h4>
                        <div className="contact-page-social-icons">
                            <a href="#"><Facebook size={20} className="social-icon" /></a>
                            <a href="#"><Twitter size={20} className="social-icon" /></a>
                            <a href="#"><Instagram size={20} className="social-icon" /></a>
                        </div>
                    </div>
                </div>

                {/* --- Right Section: Contact Form --- */}
                <div className="contact-page-form-panel">
                    <h2 className="contact-page-form-title">How can we improve your experience?</h2>
                    <form className="contact-page-form" onSubmit={handleSubmit}>
                        
                        <div className="contact-page-input-row">
                            <div className="contact-page-input-group">
                                <label htmlFor="name" className="contact-page-label">Name</label>
                                <input 
                                    type="text" 
                                    id="name" 
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="contact-page-input"
                                    required
                                />
                            </div>
                            <div className="contact-page-input-group">
                                <label htmlFor="email" className="contact-page-label">Email</label>
                                <input 
                                    type="email" 
                                    id="email" 
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    className="contact-page-input"
                                    required
                                />
                            </div>
                        </div>

                        <div className="contact-page-input-full">
                            <label htmlFor="subject" className="contact-page-label">Subject</label>
                            <input 
                                type="text" 
                                id="subject" 
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                className="contact-page-input"
                            />
                        </div>

                        <div className="contact-page-input-full">
                            <label htmlFor="description" className="contact-page-label">Description</label>
                            <textarea 
                                id="description" 
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                className="contact-page-textarea"
                                rows="6"
                                required
                            />
                            {/* Icons within textarea as seen in image (for placeholder use) */}
                            {/* <div className="contact-page-textarea-icons">
                                <span><Globe size={16} /></span>
                                <span><Mail size={16} /></span>
                            </div> */}
                        </div>

                        <button type="submit" className="contact-page-submit-btn">Submit</button>
                    </form>
                </div>

            </main>
        </div>
</div>
    );
};

export default ContactPage;